export default __webpack_public_path__ + "static/media/CRS_7104-HDR-min.a355edc5.jpg";